import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { useSettingsStore } from './features/retrieval/stores/settings';
import en from './locales/en.json';
import vi from './locales/vi.json';

const getStoredLanguage = () => {
  try {
    const settingsString = localStorage.getItem('settings-storage');
    if (settingsString) {
      const settings = JSON.parse(settingsString);
      return settings.state?.language || 'vi';
    }
  } catch (e) {
    console.error('Failed to get stored language:', e);
  }
  return 'vi';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    vi: { translation: vi }
  },
  lng: getStoredLanguage(), // Use stored language settings
  fallbackLng: 'vi',
  interpolation: {
    escapeValue: false
  },
  // Configuration to handle missing translations
  returnEmptyString: false,
  returnNull: false
});

// Subscribe to language changes
useSettingsStore.subscribe((state) => {
  const currentLanguage = state.language;
  if (i18n.language !== currentLanguage) {
    i18n.changeLanguage(currentLanguage);
  }
});

export default i18n;
